import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "الأحكام والشروط",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Title} = _components;
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: " الأحكام والشروط "
    }), "\n", _jsx(_components.p, {
      children: "يشجّع التقرير العالمي لرصد التعليم على استخدام الموقع الإلكتروني الخاص بالتقدّم المحرز في مجال التعليم لأغراض الإعلام فقط. وجميع محتويات هذا الموقع محمية بحقوق المؤلف. ويشكل دخولك للموقع واستخدام أي محتوى ورد فيه، إقراراً منك (\"المستخدم\") بأنك قرأت شروط الاستخدام وفهمتها قراءةً وفهماً تامين، ووافقت على الالتزام بها."
    }), "\n", _jsx(_components.p, {
      children: "نُشرت المعلومات الواردة في هذا الموقع الإلكتروني لكي يسهل استخدامها الشخصي أو العمومي غير التجاري ويجوز إعادة نشرها، جزئياً أو كلياً، وبأية وسيلة، بدون دفع أي رسم أو الحصول على إذن إضافي باستثناء الحالات التي يذكر فيها خلاف ذلك. وينبغي أن تُحال جميع الطلبات المتعلقة بالاستخدام التجاري وحقوق الترجمة إلى gemreport@unesco.org."
    }), "\n", _jsx(_components.h2, {
      id: "المستخدمون-ملزمون-بما-يلي",
      children: "المستخدمون ملزمون بما يلي:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "بذل العناية الواجبة في ضمان دقة المضامين المعاد نشرها؛"
      }), "\n", _jsx(_components.li, {
        children: "الإشارة إلى المصدر إشارةً واضحةً إلى جانب البيانات باستخدام النسق التالي:"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["المصدر: (إن لزم الأمر \"مكيف من\") التقرير العالمي لرصد التعليم، التقدّم المحرز في مجال التعليم،\n", _jsx(_components.a, {
        href: "",
        children: "https://www.education-progress.org"
      }), "، تاريخ استخراج المضامين."]
    }), "\n", _jsx(_components.p, {
      children: "وينبغي العلم بأن قاعدة البيانات تُحدَّث وتُراجع بانتظام. لذا، من المهم ذكر تاريخ استخراج المضامين عند اقتباس بيانات وردت في الموقع."
    }), "\n", _jsx(_components.h2, {
      id: "التراخيص",
      children: "التراخيص"
    }), "\n", _jsx(_components.p, {
      children: "نشجعك على استخدام البيانات من أجل إفادة نفسك وغيرك بطرائق ابتكارية. ويجوز لك استخراج المعلومات الواردة في مجموعات البيانات وتنزيلها واستنساخها، ويجوز لك تبادل تلك المعلومات مع جهات أخرى."
    }), "\n", _jsx(_components.h2, {
      id: "لا-شراكة-ولا-تأييد",
      children: "لا شراكة ولا تأييد"
    }), "\n", _jsx(_components.p, {
      children: "لا يجوز للمستخدم الإشارة صراحة أو ضمناً إلى أن التقرير العالمي لرصد التعليم شارك في استخدامه أو إعادة نشره للمضامين أو وافق على ذلك أو أيّده أو دعمه بأية طريقة. ولا يجوز للمستخدم أن يدعي أنه ينتسب إلى الموقع الإلكتروني الخاص بالتقدّم المحرز في مجال التعليم (أو إلى التقرير العالمي لرصد التعليم)."
    }), "\n", _jsx(_components.h2, {
      id: "الروابط-المؤدية-إلى-الموقع-الإلكتروني",
      children: "الروابط المؤدية إلى الموقع الإلكتروني"
    }), "\n", _jsx(_components.p, {
      children: "يجوز لموقع إلكتروني خارجي أن يضم رابطاً إلكترونياً مؤدياً إلى أية صفحة من صفحات الموقع الخاص بالتقدّم المحرز في مجال التعليم من غير استئذان. غير أنه يجب ألا يفضي ذلك إلى خرق حقوق الملكية الفكرية للتقرير العالمي لرصد التعليم، ولا سيما فيما يخص الأسماء أو الشعارات أو حقوق التأليف والنشر أو حقوق المؤلِّف."
    }), "\n", _jsx(_components.h2, {
      id: "إخلاء-المسؤولية",
      children: "إخلاء المسؤولية"
    }), "\n", _jsx(_components.p, {
      children: "يُشرف التقرير العالمي لرصد التعليم على هذا الموقع الإلكتروني بغية الارتقاء باطلاع الجمهور على البيانات والمعلومات ذات الصلة بالموضوع. ويبذُل قصارى جهده لتكون المعلومات الواردة في هذا الموقع دقيقة وكاملة، ولكن ليس بوسعه ضمان ذلك. وهدفنا هو أن تظل تلك المعلومات محدَّثة ودقيقة. وإذا استرعي انتباهنا إلى أخطاء، فسنسعى إلى تصحيحها."
    }), "\n", _jsx(_components.p, {
      children: "ولا تعبّر التسميات المستخدمة في مضامين الموقع وطريقة عرض تلك المضامين على الموقع عن أي رأي لليونسكو بشأن الحالة القانونية لأي بلد أو إقليم أو مدينة أو منطقة، ولا بشأن سلطات هذه الأماكن أو بشأن رسم حدودها أو تخومها."
    }), "\n", _jsx(_components.p, {
      children: "ويتحمل التقرير العالمي لرصد التعليم المسؤولية عن اختيار المضامين الوقائعية الواردة في هذا الموقع وطريقة عرضها، ولا تمثل تلك المضامين بالضرورة وجهات نظر اليونسكو ولا تلزم المنظمة بأي شيء."
    }), "\n", _jsx(_components.p, {
      children: "ونبذل قصارى جهدنا بغية التقليل إلى أدنى حد من الاختلال الناجم عن الأخطاء التقنية. لكن بعض البيانات أو المعلومات الواردة في الموقع قد تكون أُنشئت أو نُظِّمت في ملفات أو أنساق مختلة، لذا لا نستطيع ضمان ألا تنقطع الخدمة أو ألا تتأثّر بمثل هذه المشكلات بطريقة أخرى. ولا يتحمّل التقرير العالمي لرصد التعليم أية مسؤولية فيما يخص مثل هذه المشكلات (من قبيل الإخفاق في الأداء و الفيروراسات الحاسوبية وإخفاق خط الاتصال و تعديل المضامين وما إلى ذلك) الناتجة عن استخدام الموقع الخاص بالتقدّم المحرز في مجال التعليم أو أي رابط مؤدٍ إلى مواقع خارجية."
    }), "\n", _jsx(_components.h2, {
      id: "حرمة-الشؤون-الشخصية",
      children: "حرمة الشؤون الشخصية"
    }), "\n", _jsx(_components.p, {
      children: "بمجرّد دخول الموقع الإلكتروني الخاص بالتقدّم المحرز في مجال التعليم، ستُحفظ في خوادمنا معلومات من قبيل عناوين بروتوكول الإنترنت وسلوك تصفّح الموقع والبرمجية المستخدمة والوقت المقضي، إضافةً إلى معلومات مماثلة أخرى. ولن تشير تلك المعلومات إلى أسماء المستخدمين وستسخَّر لتحليل حركة زيارة الموقع."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
